<template>
  <section class="dressing-room-app">
    <div class="dressing-room-app__padding">
      <div class="dressing-room-app__stage">
        <section class="page-area">

          <!-- MAKING A YOUNG ACTOR LOOK OLD -->
          <div class="page page--0" v-if="currentPage === 0">
          
            <div class="actor"></div>

              <div class="page__instructions">
                <p class="page__title_intro"><strong>how to apply age make-Up</strong></p>
                <p class="page__sub_title_intro">making a young actor look old</p>
                <p class="page__text">Auditions have been held for Shakespeare's "Romeo and Juliet" and a young actor has been cast as the Nurse, the older woman who takes care of Juliet. <br>The make-up artist must transform the actor's face and hair.</p>
              
            </div>
          </div>

          <!-- TRY OUT THE WIG -->
          <div class="page page--1" v-if="currentPage === 1">
            <div class="shift">
              <Container group-name="dndWig" @drop="dndWigDrop" :should-animate-drop="()=>false">
                <div class="actor" v-if="!hasToolBeenUsed"></div>
                <div class="actor_old" v-if="hasToolBeenUsed"></div>
              </Container>
            </div>

            <div class="page__instructions">
              <p class="page__title_shift">how to apply age make-Up</p>
              <p class="page__sub_title">try out the wig</p>
              <p class="page__text">Begin by dragging the gray wig onto the actor's head to help picture how much make-up is needed and where it should go on the actor's face.</p>
              <div class="tool-box-clear">
                <p class="wig-text">WIG</p>
                  <div class="tool-box__area">
                    <Container group-name="dndWig" :drag-begin-delay="0">
                      <Draggable v-if="!hasToolBeenUsed">
                        <div class="tool tool--wig"></div>
                      </Draggable>
                      <div class="tool tool--base"></div>
                    </Container>
                      
                  </div>
              </div>
            </div>
          </div>

          <!-- SELECT THE BASE -->
          <div class="page page--2" v-show="currentPage === 2">
          {{ currentPage === 2 ? scene2Scrubbing() : ''}}
            <!-- <div class="actor"></div> -->
            <div class="shift">
            <div class="interactive-box">
              <div class="interactive-box--warm" v-show="scene2canvasType === 'warm'">
                <canvas style='position: absolute; top: 0; left: 0;' id="scene2BottomCanvasWarm"></canvas>
                <canvas style='position: absolute; top: 0; left: 0;' id="scene2TopCanvasWarm"></canvas>
                <canvas style='display: none;' id="scene2PatternCanvasWarm"></canvas>
              </div>
              <div class="interactive-box--cool" v-show="scene2canvasType === 'cool'">
                <canvas style='position: absolute; top: 0; left: 0;' id="scene2BottomCanvasCool"></canvas>
                <canvas style='position: absolute; top: 0; left: 0;' id="scene2TopCanvasCool"></canvas>
                <canvas style='display: none;' id="scene2PatternCanvasCool"></canvas>
              </div>
            </div>
            </div>

              <div class="page__instructions">
                <p class="page__title"><strong>how to apply age make-Up</strong></p>
                <p class="page__sub_title">select the base</p>
                <p class="page__text">With the wig off, select a warm or cool base by clicking on a sponge and rubbing it over the actor's face. The warm base gives a healthy look. The cool base makes the actor appear pale or maybe sickly.</p>
                <div class="tool-box">
                  <div class="tool-box__area-double" style="display: flex;">
                    
                    <div class="tool-box__area-double__left-double">
                      <div class="tool tool--warm"></div>
                      <p class="text-double">warm base</p>
                    <vue-draggable-resizable @dragging="onDraggingWarmBase" @dragstop="onDragStop" id="scene2tool_1">
                    <div class="tool tool--sponge--warm "></div>
                    </vue-draggable-resizable>
                    </div>

                    <div class="tool-box__area-double__right-double">
                      <div class="tool tool--cool"></div>
                      <p class="text-double">cool base</p>
                    <vue-draggable-resizable @dragging="onDraggingCoolBase" @dragstop="onDragStop" id="scene2tool_2">
                    <div class="tool tool--sponge--cool"></div>
                    </vue-draggable-resizable>
                    </div>

                  </div>
              </div>
              </div>
          </div>

          <!-- CREATE SHADOWS -->
          <div class="page page--3" v-show="currentPage === 3">
            {{ currentPage === 3 ? scene3Scrubbing() : ''}}
            <div class="shift">
              <div class="interactive-box">
                <canvas style='position: absolute; top: 0; left: 0;' id="scene3BottomCanvas"></canvas>
                <canvas style='position: absolute; top: 0; left: 0;' id="scene3TopCanvas"></canvas>
                <canvas style='display: none;' id="scene3PatternCanvas"></canvas>
              </div>
            </div>

            <div class="page__instructions">
              <p class="page__title"><strong>how to apply age make-Up</strong></p>
              <p class="page__sub_title">create shadows</p>
              <p class="page__text">The Nurse is a healthy character so we have selected the warm base. Drag the brush across the actor's face to create shadows with a darker shade of make-up. Older faces have one or more wrinkles and hollow areas than young ones.</p>
              <div class="new_toolbox">
                <div class="new_toolbox__area-single" style="display: flex;">

                  <div class="new_toolbox__area-single__left-single">
                    <div class="tool tool--shadow_makeup"></div>
                    <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop" id="scene3tool">
                    <div class="tool tool--brush-shadow"></div>
                    </vue-draggable-resizable>
                  </div>

                  <div class="new_toolbox__area-single__right-single">
                    <p class="text-single">Shadow make-Up</p>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!-- ADD HIGHLIGHTS -->
          <div class="page page--4" v-show="currentPage === 4">
            {{ currentPage === 4 ? scene4Scrubbing() : ''}}
            <div class="shift">
              <div class="interactive-box">
                <canvas style='position: absolute; top: 0; left: 0;' id="scene4BottomCanvas"></canvas>
                <canvas style='position: absolute; top: 0; left: 0;' id="scene4TopCanvas"></canvas>
                <canvas style='display: none;' id="scene4PatternCanvas"></canvas>
              </div>
            </div>
            <div class="page__instructions">
              <p class="page__title"><strong>how to apply age make-Up</strong></p>
              <p class="page__sub_title">add highlights</p>
              <p class="page__text">Apply a lighter base by dragging the brush over the face. Highlights on the cheek, chin and forehead make the shaded areas stand out.</p>
              <div class="new_toolbox">
                <div class="new_toolbox__area-single" style="display: flex;">

                  <div class="new_toolbox__area-single__left-single">
                    <div class="tool tool--highlight_makeup"></div>
                    <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop" id="scene4tool">
                    <div class="tool tool--brush-highlight"></div>
                    </vue-draggable-resizable>
                  </div>

                  <div class="new_toolbox__area-single__right-single">
                    <p class="text-single">Hi-light make-Up</p>
                  </div>

                    
                  
                </div>
              </div>
            </div>
          </div>

          <!-- FINALLY -->
          <div class="page page--5" v-show="currentPage === 5">
            <div class="shift">
            <div class="actor_final"></div>
            </div>
              <div class="page__instructions">
                <p class="page__title_shift"><strong>how to apply age make-Up</strong></p>
                <p class="page__sub_title">finally</p>
                <p class="page__text">With the wig back on and wrinkle lines added, the young actor looks the part of Juliet's Nurse.</p>
              
                <a href="https://www.knowitall.org/series/stage"> <div class="tool tool--stage_button"></div></a>
                          
            </div>
          </div>

          <div class="page page--6" v-show="currentPage === 6">
            page 6
          </div>

          <div class="dressing-room-app__nav">
            <button v-show="currentPage > 0 && currentPage !== 5" @click="prevPage" class="i-btn i-btn--back">Back</button>
            <button v-if="currentPage < 5" @click="nextPage" class="i-btn i-btn--next">Next</button>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import { Howl } from 'howler'
// import VueDraggableResizable from 'vue-draggable-resizable'
import { Container, Draggable } from 'vue-smooth-dnd';

export default {
  name: 'app',
  components: {
    Container,
    Draggable,
    // VueDraggableResizable,
  },
  data: function () {
    return {
      isDragging: false,
      hasToolBeenUsed: false,
      currentPage: 0,
      currentSoundId: null,
      audio: new Howl({
        src: ['audio/dressing-room-sounds.mp3'],
        sprite: {
          ding: [733, 104],
          wig: [3326, 207]
        }
      }),
      scene2canvasType: 'warm',
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    nextPage() {
      const pageBeforeLeaving = this.currentPage;
      if (this.currentPage < 5) {
        this.audio.play('ding');
        this.currentPage++;
        this.resetTools(pageBeforeLeaving);
      }
    },
    prevPage() {
      const pageBeforeLeaving = this.currentPage;
      if (this.currentPage > 0) {
        this.audio.play('ding');
        this.currentPage--;
        this.resetTools(pageBeforeLeaving);
      }
    },
    resetTools() {
      this.hasToolBeenUsed = false;
    },
    onDragging() {
      if (!this.isDragging) {
        this.isDragging = true;
      }
    },
    onDraggingWarmBase(){
      this.scene2canvasType = 'warm';
      this.onDragging();
      // TODO: Clear cool canvas
    },
    onDraggingCoolBase(){
      this.scene2canvasType = 'cool';
      this.onDragging();
      // TODO: Clear warm canvas
    },
    onDragStop() {
      if (this.isDragging) {
        this.isDragging = false;
        this.currentSoundId = null;
      }
    },
    drawPattern(x, y, topCtx, bottomCtx, patternCanvas) {
      if (this.isDragging) {
        // topCtx.fillStyle = '#F00000';
        topCtx.fillStyle = bottomCtx.createPattern(patternCanvas, 'no-repeat');
        topCtx.beginPath();
        topCtx.arc(x, y, ((20 * window.innerWidth)/725), 0, Math.PI * 2, true);
        topCtx.fill();
        // console.log({x:x,y:y});
      }
    },

    scene2Scrubbing() {
      this.scene2ScrubbingWarm();
      this.scene2ScrubbingCool();
    },
    scene2ScrubbingWarm() {
      let bottomCanvas = document.getElementById('scene2BottomCanvasWarm');
      let topCanvas = document.getElementById('scene2TopCanvasWarm');
      let patternCanvas = document.getElementById('scene2PatternCanvasWarm');

      const bottomCtx = bottomCanvas.getContext('2d');
      const mbCtx = patternCanvas.getContext('2d');

      const bottomImage = new Image();
      const topImage = new Image();

      bottomImage.onload = function () {
        bottomCanvas.width = bottomCanvas.clientWidth;
        bottomCanvas.height = bottomCanvas.clientHeight;
        bottomCtx.drawImage(bottomImage, 0, 0, bottomImage.width, bottomImage.height, 0, 0, bottomCanvas.clientWidth, bottomCanvas.clientHeight);
      };

      topImage.onload = function () {
        patternCanvas.width = bottomCanvas.clientWidth;
        patternCanvas.height = bottomCanvas.clientHeight;
        mbCtx.drawImage(topImage, 0, 0, topImage.width, topImage.height, 0, 0, bottomCanvas.clientWidth, bottomCanvas.clientHeight);
      };

      bottomImage.src = require('./assets/img/scene1--young.svg');
      topImage.src = require('./assets/img/scene2--warm.svg');
  
      const tool = document.getElementById('scene2tool_1');
      const scene2WarmSettings = {
        tool: tool,
        topCanvas: topCanvas,
        bottomCanvas: bottomCanvas,
        patternCanvas: patternCanvas,
        onMouseMove: this.drawPattern,
        preventDefault: true
      };

      this.setupMouse(scene2WarmSettings);
    },
    scene2ScrubbingCool() {
      let bottomCanvas = document.getElementById('scene2BottomCanvasCool');
      let topCanvas = document.getElementById('scene2TopCanvasCool');
      let patternCanvas = document.getElementById('scene2PatternCanvasCool');

      const bottomCtx = bottomCanvas.getContext('2d');
      const mbCtx = patternCanvas.getContext('2d');

      const bottomImage = new Image();
      const topImage = new Image();

      bottomImage.onload = function () {
        bottomCanvas.width = bottomCanvas.clientWidth;
        bottomCanvas.height = bottomCanvas.clientHeight;
        bottomCtx.drawImage(bottomImage, 0, 0, bottomImage.width, bottomImage.height, 0, 0, bottomCanvas.clientWidth, bottomCanvas.clientHeight);
      };

      topImage.onload = function () {
        patternCanvas.width = bottomCanvas.clientWidth;
        patternCanvas.height = bottomCanvas.clientHeight;
        mbCtx.drawImage(topImage, 0, 0, topImage.width, topImage.height, 0, 0, bottomCanvas.clientWidth, bottomCanvas.clientHeight);
      };

      bottomImage.src = require('./assets/img/scene1--young.svg');
      topImage.src = require('./assets/img/scene2--cool.svg');

      const tool = document.getElementById('scene2tool_2');
      const scene2CoolSettings = {
        tool: tool,
        topCanvas: topCanvas,
        bottomCanvas: bottomCanvas,
        patternCanvas: patternCanvas,
        onMouseMove: this.drawPattern,
        preventDefault: true
      };

      this.setupMouse(scene2CoolSettings);
    },
    scene3Scrubbing() {
      let bottomCanvas = document.getElementById('scene3BottomCanvas');
      let topCanvas = document.getElementById('scene3TopCanvas');
      let patternCanvas = document.getElementById('scene3PatternCanvas');

      const bottomCtx = bottomCanvas.getContext('2d');
      const mbCtx = patternCanvas.getContext('2d');

      const bottomImage = new Image();
      const topImage = new Image();

      bottomImage.onload = function () {
        bottomCanvas.width = bottomCanvas.clientWidth;
        bottomCanvas.height = bottomCanvas.clientHeight;
        bottomCtx.drawImage(bottomImage, 0, 0, bottomImage.width, bottomImage.height, 0, 0, bottomCanvas.clientWidth, bottomCanvas.clientHeight);
      };

      topImage.onload = function () {
        patternCanvas.width = bottomCanvas.clientWidth;
        patternCanvas.height = bottomCanvas.clientHeight;
        mbCtx.drawImage(topImage, 0, 0, topImage.width, topImage.height, 0, 0, bottomCanvas.clientWidth, bottomCanvas.clientHeight);
      };

      bottomImage.src = require('./assets/img/scene3--before.svg');
      topImage.src = require('./assets/img/scene3--after.svg');

      const tool = document.getElementById('scene3tool');
      const scene3Settings = {
        tool: tool,
        topCanvas: topCanvas,
        bottomCanvas: bottomCanvas,
        patternCanvas: patternCanvas,
        onMouseMove: this.drawPattern,
        preventDefault: true
      };

      this.setupMouse(scene3Settings);
    },

    scene4Scrubbing() {
      let bottomCanvas = document.getElementById('scene4BottomCanvas');
      let topCanvas = document.getElementById('scene4TopCanvas');
      let patternCanvas = document.getElementById('scene4PatternCanvas');

      const bottomCtx = bottomCanvas.getContext('2d');
      const mbCtx = patternCanvas.getContext('2d');

      const bottomImage = new Image();
      const topImage = new Image();

      bottomImage.onload = function () {
        bottomCanvas.width = bottomCanvas.clientWidth;
        bottomCanvas.height = bottomCanvas.clientHeight;
        bottomCtx.drawImage(bottomImage, 0, 0, bottomImage.width, bottomImage.height, 0, 0, bottomCanvas.clientWidth, bottomCanvas.clientHeight);
      };

      topImage.onload = function () {
        patternCanvas.width = bottomCanvas.clientWidth;
        patternCanvas.height = bottomCanvas.clientHeight;
        mbCtx.drawImage(topImage, 0, 0, topImage.width, topImage.height, 0, 0, bottomCanvas.clientWidth, bottomCanvas.clientHeight);
      };

      bottomImage.src = require('./assets/img/scene3--after_2.svg');
      topImage.src = require('./assets/img/scene4--after_3.svg');

      const tool = document.getElementById('scene4tool');
      const scene3Settings = {
        tool: tool,
        topCanvas: topCanvas,
        bottomCanvas: bottomCanvas,
        patternCanvas: patternCanvas,
        onMouseMove: this.drawPattern,
        preventDefault: true
      };

      this.setupMouse(scene3Settings);
    },
    setupMouse(settings) {
      let {
        topCanvas,
        bottomCanvas,
        patternCanvas,
        onMouseMove,
        preventDefault,
        tool,
      } = settings;

      let mouse = {
        x: 0,
        y: 0,
        down: false
      };


      // const context = canvas.getContext('2d');
      // context.clearRect(0, 0, canvas.width, canvas.height);

      let rectLeft, rectTop;
      const bottomCtx = bottomCanvas.getContext('2d'); 
      const topCtx = topCanvas.getContext('2d'); 
      const hook = topCanvas.addEventListener.bind(topCanvas);
      const mouseDown = updateMouseStatus.bind(null, true);
      const mouseUp = updateMouseStatus.bind(null, false);
      const toolHook = tool.addEventListener.bind(tool);

      toolHook('touchmove', updateCoordinates);
      hook('mousedown', mouseDown);
      hook('mouseup', mouseUp);
      hook('mousemove', updateCoordinates);
      hook('scroll', updateRect);

      function updateMouseStatus(b, e) {
        mouse.down = b;
        updateCoordinates(e);
        if (preventDefault) {
          e.stopPropagation();
          e.preventDefault();
        }
      }

      function updateCoordinates(e) {
        if (e.type === 'touchmove') {
          mouse.x = (Math.floor(e.touches[0].clientX) - rectLeft);
          mouse.y = (Math.floor(e.touches[0].clientY) - rectTop);
        } else {
          mouse.x = (e.clientX - rectLeft);
          mouse.y = (e.clientY - rectTop);
        }

        onMouseMove(mouse.x, mouse.y, topCtx, bottomCtx, patternCanvas);
        updateRect();
      }

      function updateRect() {
        const cWidth = topCanvas.clientWidth;
        const cHeight = topCanvas.clientHeight;

        if (topCanvas.width !== cWidth || topCanvas.height !== cHeight) {
          topCanvas.width = cWidth;
          topCanvas.height = cHeight;
        }

        const rect = topCanvas.getBoundingClientRect();
        rectLeft = Math.floor(rect.left);
        rectTop = Math.floor(rect.top);
      }

      updateRect();
    },

    dndWigDrop(dropResult) {
      const {addedIndex} = dropResult;
      // console.log(addedIndex);
      if (addedIndex !== null) {
        this.hasToolBeenUsed = true;
        this.audio.play('wig');
      }
    },
  }
}
</script>

<style lang="scss">
@import "style";

.hide-tool {
  z-index: -1;
}

body{
  overflow: hidden;
}

.smooth-dnd-container {
  .animated {
    transform: none !important;
  }
}

// .smooth-dnd-container{ 
//   width: fluid(256px);
// height: fluid(251px);
// }

.dressing-room-app {
  background: $yellow;
  margin: 0;
  padding: 0;

  &__nav {
    // position: relative;
    // bottom: fluid(30px);
    // right: fluid(-400px);
    position: absolute;
    right: fluid(110px);
    bottom: -30%;
    width: fluid(180px);

    button {
      font-family: $cursive;
      text-transform: uppercase;
      cursor: pointer;
    }
  }

  &__padding {
    position: relative;
    padding: 0 0 #{(380/725)*100%};
  }

  &__stage {
    // display: flex;
    padding: fluid(16px);
    overflow: hidden;
    position: absolute;
    width: 100%;
    height:100%;
  }
}

.page-area {
  width: 100%;
  position: relative;
  margin: auto;
}

.page {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  max-width: fluid(550px);
  max-height: fluid(251px);
  margin: auto;
  margin-top: 3%;

  &__title {
    font-family: $cursive;
    font-weight: 300;
    text-align: center;
    color: lighten(#820C0C, 0%);
    text-shadow: fluid(1px) fluid(1px) fluid(.5px) black;
    margin: 0 auto;
    font-size: fluid(30px);
    text-transform: capitalize;
    word-spacing: fluid(5px);
    width: 100%;
  }

  &__title_intro {
    font-family: $cursive;
    font-weight: 300;
    text-align: left;
    text-indent: fluid(24px);
    color: lighten(#820C0C, 0%);
    text-shadow: fluid(1px) fluid(1px) fluid(.5px) black;
    margin: 0 auto;
    font-size: fluid(30px);
    text-transform: capitalize;
    word-spacing: fluid(5px);
    width: 100%;
    padding-bottom: fluid(6px);
  }

  &__title_shift {
    font-family: $cursive;
    font-weight: 300;
    text-align: left;
    text-indent: fluid(24px);
    color: lighten(#820C0C, 0%);
    text-shadow: fluid(1px) fluid(1px) fluid(.5px) black;
    margin: 0 auto;
    font-size: fluid(30px);
    text-transform: capitalize;
    word-spacing: fluid(5px);
    width: 100%;
  }

  &__sub_title {
    text-align: center;
    width: 100%;
    text-transform: uppercase;
    color: #000;
    font-size: fluid(15.3px);
    margin: 0;
    padding: fluid(8px) fluid(0px);
    // text-indent: fluid(15px);
  }

&__sub_title_intro {
    text-align: left;
    width: 100%;
    text-transform: uppercase;
    color: #000;
    font-size: fluid(15.3px);
    margin: 0;
    padding: fluid(15px) fluid(0px);
    text-indent: fluid(15px);
  }


  &__instructions {
    flex: 0 0 auto;
    padding: fluid(0px) fluid(0px);
    text-align: left;
    // width: 100%;
    color: #000;
    font-size: fluid(10px);
    margin-bottom: fluid(35px);
    word-wrap: none;
    width: fluid(360px); 
  }

  &__text{
    width: 100%;
    padding: fluid(0px) fluid(0px);
    color: #000;
    font-size: fluid(15px);
    margin: 0;
    padding-bottom: 5%;
  }

}

.shift{
  position: relative;
  left: fluid(0px);
}

.actor{
  flex: 0 0 auto;
      background: url('~@/assets/img/scene1--young.svg');
      background-size: contain;
      background-repeat: no-repeat;
      width: fluid(256px);
      height: fluid(275px);
}

.actor_old{
  flex: 0 0 auto;
      background: url('~@/assets/img/scene2--old.svg');
      background-size: contain;
      background-repeat: no-repeat;
      width: fluid(256px);
      height: fluid(275px);
}

.actor_shadow{
  flex: 0 0 auto;
      background: url('~@/assets/img/scene3--actor.svg');
      background-size: contain;
      background-repeat: no-repeat;
      width: fluid(256px);
      height: fluid(251px);
}

.actor_final{
  flex: 0 0 auto;
      background: url('~@/assets/img/scene5--final.svg');
      background-size: contain;
      background-repeat: no-repeat;
      width: fluid(256px);
      height: fluid(275px);
}

.tool-box-clear {
  // width: fluid(260px);
  // height: fluid(100px);
  width: 100%;
  height: fluid(85px);
  padding: fluid(0px);
  display: flex;
  position: relative;

  p {
    font-family: $cursive;
    width: 60%;
    padding: fluid(0px) fluid(50px);
    text-align: right;
    text-transform: uppercase;
    color: #000;
    font-size: fluid(26px);
    margin: 0 auto;
  }
}

.tool-box {
  width: fluid(190px);
  height: fluid(80px);
  // height: fluid(89px);
  // left: fluid(50px);
  margin: 0 auto;
  border-radius: fluid(14px);
  display: flex;
  flex-flow: row wrap;
  position: relative;
  background: #342A21;
  box-shadow: fluid(3px) fluid(3px) 0px 0px rgba(155,115,50,1);

  p {
    font-family: $cursive;
    width: 100%;
    padding: fluid(0px) fluid(50px);
    text-align: right;
    text-transform: uppercase;
    color: #fff;
    font-size: fluid(20px);
    margin: 0;
  }

  &__area {
    display: flex;
    position: absolute;
    flex-flow: row wrap;
  justify-content: space-around;
  margin: auto;
    top: 5%;
    width: 100%;

    &__left{
      width: 50%;
      height: 100%;
      color: white;
      font-family: $cursive;
      text-align: center;

      .base_text{
        position: relative;
        width: 100px;
        left: fluid(-10px);
        padding: 0% 50%;
        font-size: fluid(16px);
        text-transform: lowercase;
        line-height: fluid(14px);
      }
    }

    &__right{
      width: 50%;
      height: 100%;
      color: white;
      font-family: $cursive;
      text-align: center;

      .base_text{
        position: relative;
        left: fluid(-10px);
        padding: 0% 50%;
        
        font-size: fluid(16px);
        text-transform: lowercase;
        line-height: fluid(14px);
      }
    }
  }

  &__area-single{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  
    &__left-single{
      width: 50%;
    }

    &__right-single{
      margin: auto;
      width: 50%;

      .text-single{
        font-family: $cursive;
        width: 60%;
        padding: fluid(0px) fluid(0px);
        text-align: left;
        color: #fff;
        font-size: fluid(14px);
        line-height: fluid(14px);
        margin-left: fluid(0px);
        text-transform: capitalize;
      }
    }
  }

  &__area-double{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  
    &__left-double{
      width: 50%;
    }

    &__right-double{
      margin: auto;
      width: 50%;
    }
    .text-double{
        font-family: $cursive;
        width: 60%;
        padding: fluid(0px) fluid(0px);
        text-align: left;
        color: #fff;
        font-size: fluid(22px);
        line-height: fluid(16px);
        margin: auto;
        text-transform: lowercase;
      }
  }
}

.new_toolbox{
  width: fluid(150px);
  height: fluid(70px);
  // height: fluid(89px);
  // left: fluid(50px);
  margin: 0 auto;
  border-radius: fluid(14px);
  display: flex;
  flex-flow: row wrap;
  position: relative;
  background: #342A21;
  box-shadow: fluid(3px) fluid(3px) 0px 0px rgba(155,115,50,1);

  &__area-single{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  
    &__left-single{
      width: 50%;
    }

    &__right-single{
      margin: auto;
      width: 50%;

      .text-single{
        font-family: $cursive;
        width: 100%;
        padding: fluid(0px) fluid(0px);
        text-align: left;
        color: #fff;
        font-size: fluid(22px);
        line-height: fluid(16px);
        margin-left: fluid(0px);
        margin: 0 auto;
        text-transform:lowercase;
      }
    }
  }  
}

.wig-text{
  width: 50%;
}

.tool {
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;

  &--combo {
    display: flex;
  }

  &--wig {
    position: absolute;
    background-image: url('~@/assets/img/scene2--wig.svg');
    width: fluid(80px);
    height: fluid(100px);
    right: fluid(-5px);
    top: fluid(-6px);
    // margin: 0 auto;
    z-index: 2;
  }

  &--base {
    position: absolute;
    margin: 0 auto;
    top: fluid(0px);
    right: fluid(-10px);
    background-image: url('~@/assets/img/scene2--base.svg');
    width: fluid(75px);
    height: fluid(100px);
    z-index: 1;
  }

  &--warm {
    margin: 0 fluid(20px);
    width: fluid(30px);
    height: fluid(30px);
    border-radius: fluid(50px);
    background: #E78452;
    border: 3px solid #000;
    box-shadow: fluid(-2px) fluid(2px) fluid(0px) fluid(0px) rgba(0,0,0,1);
    z-index: 2;
  }

  &--cool {
    margin: 0 fluid(20px);
    width: fluid(30px);
    height: fluid(30px);
    border-radius: fluid(50px);
    background: #E0B79B;
    border: 3px solid #000;
    box-shadow: fluid(-2px) fluid(2px) fluid(0px) fluid(0px) rgba(0,0,0,1);
    z-index: 2;
  }

  &--sponge--warm {
    position: absolute; 
    top: fluid(8px);
    left: fluid(30px);
    background-image: url('~@/assets/img/scene3--sponge.svg');
    width: fluid(45px);
    height: fluid(45px);
    z-index: 2;
  }

  &--sponge--cool {
    position: absolute;
    top: fluid(8px);
    left: fluid(125px);
    background-image: url('~@/assets/img/scene3--sponge.svg');
    width: fluid(45px);
    height: fluid(45px);
    z-index: 2;
  }

  &--brush-highlight {
    position: relative; 
    background-image: url('~@/assets/img/scene4--brush.svg');
    width: fluid(65px);
    height: fluid(47px);
    top: fluid(0px);
    left: fluid(30px);
    z-index: 2;
  }

  &--brush-shadow {
    position: relative;
    background-image: url('~@/assets/img/scene3--brush.svg');
    width: fluid(65px);
    height: fluid(47px);
    top: fluid(-5px);
    left: fluid(30px);
    z-index: 2;
  }

  &--brush-highlight {
    position: relative; 
    background-image: url('~@/assets/img/scene4--brush.svg');
    width: fluid(59px);
    height: fluid(41px);
    z-index: 2;
  }

  &--highlight_makeup{
    margin: auto;
    width: fluid(30px);
    height: fluid(30px);
    border-radius: fluid(50px);
    background: #EF9C7B;
    border: 3px solid #000;
    box-shadow: fluid(-2px) fluid(2px) 0px 0px rgba(0,0,0,1);
    z-index: 2;
  }

  &--shadow_makeup{
    margin: auto;
    width: fluid(30px);
    height: fluid(30px);
    border-radius: fluid(50px);
    background: #B95E2E;
    border: 3px solid #000;
    box-shadow: fluid(-2px) fluid(2px) 0px 0px rgba(0,0,0,1);
    z-index: 2;
  }

  &--stage_button {
    margin: fluid(30px) auto;
    background-image: url("~@/assets/img/button_back.svg");
    width: fluid(150px);
    height: fluid(130px);
        }
}

.draggable {
  width: auto !important;
  height: auto !important;
}

.interactive-box {
  position: relative;
  // border: 3px solid red;
  width: fluid(246px);
  height: fluid(275px);

  &--warm,
  &--cool {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  canvas {
    width: 100%;
    height: 100%;
  }
}

.i-btn {
  appearance: none;
  border: 0;
  background: transparent;
  font-weight: 600;
  margin: auto;
  font-size: fluid(18px);
  flex: 0 0 auto;

  &:before {
    content: '';
    width: fluid(35px);
    height: fluid(35px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
    margin: 0 auto;
  }

  &--back {
    float: left;
    justify-self: start;
    &:before {
      background-image: url('~@/assets/img/button_arrow_l.svg');
    }
  }

  &--next {
    float:right;
    &:before {
      background-image: url('~@/assets/img/button_arrow_r.svg');
    }
  }
}

</style>
